
export enum FleetMode  {
  FREE = 'FREE',
  PATHCOVERAGE = 'PATHCOVERAGE',
  KEEPFORMATION = 'KEEPFORMATION'
}

